$('.brand-carousel').owlCarousel({
    loop: true,
    autoplay: true,
    nav: false,
    selectedAttraction: 0.001,
    draggable: true,
    freeScroll: false,
    autoplayHoverPause: true, // Pauses autoplay on hover
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
});
